import { axiosRubyClient as api } from '@/util/axios/axiosClient';

// Mirrors Api::Admin::SmsLogsController#serialize (graphy).
export interface SmsLog {
  id: number;
  to_phone: string;
  sms_type: string | null;
  status: string;
  body: string;
  twilio_sid: string | null;
  error_message: string | null;
  worker_id: number | null;
  created_at: string;
}

export interface SmsLogFilters {
  page?: number;
  per_page?: number;
  to_phone?: string;
  sms_type?: string;
  status?: string;
}

export interface SmsLogsResponse {
  success: boolean;
  data: SmsLog[];
  pagination: {
    total: number;
    page: number;
    per_page: number;
    total_pages: number;
  };
}

export interface SmsLogDetailResponse {
  success: boolean;
  data: SmsLog;
}

export const smsLogsAPI = {
  // GET /api/admin/sms_logs — paginated, filterable debug log of outbound SMS.
  getSmsLogs: async (filters: SmsLogFilters = {}): Promise<SmsLogsResponse> => {
    const response = await api.get('/api/admin/sms_logs', { params: filters });
    return response.data;
  },

  // GET /api/admin/sms_logs/:id — full message body + delivery metadata.
  getSmsLog: async (id: number): Promise<SmsLogDetailResponse> => {
    const response = await api.get(`/api/admin/sms_logs/${id}`);
    return response.data;
  },
};
